class PopinHandler {
    private popinElement: HTMLElement;
    private readonly confirmMessageSelector = '[data-popin-confirm]';
    private readonly cf7FormSelector = '.wpcf7-form';

    constructor(popinElement: HTMLElement) {
        this.popinElement = popinElement;
        this.initEvents();
    }

    private initEvents(): void {
        const overlay = this.popinElement.querySelector('[data-popin-overlay]');
        const closeButton = this.popinElement.querySelector('[data-popin-close]');

        if (overlay && closeButton) {
            overlay.addEventListener('click', this.closePopin.bind(this));
            closeButton.addEventListener('click', this.closePopin.bind(this));
        }
        const cf7Form = this.popinElement.querySelector(this.cf7FormSelector);
        if (cf7Form) {
            cf7Form.addEventListener('wpcf7mailsent', this.handleCF7Success.bind(this) as EventListener);
        }
    }

    // Note: openPopin et closePopin sont inchangées, elles agissent sur this.popinElement
    public closePopin(): void {
        if (this.popinElement) {
            this.popinElement.classList.remove('active');
            document.body.classList.remove('unscrollable');

            const confirmMessage = this.popinElement.querySelector(this.confirmMessageSelector) as HTMLElement;
            if (confirmMessage) {
                confirmMessage.style.display = 'none';

                // Réafficher le contenu principal pour la prochaine ouverture
                const popinWrap = this.popinElement.querySelector('.popin__form') as HTMLElement;
                if (popinWrap) {
                    popinWrap.style.display = ''; // Remet l'affichage par défaut
                }
            }
        }
    }

    private handleCF7Success(event: Event): void {
        const confirmMessage = this.popinElement.querySelector(this.confirmMessageSelector) as HTMLElement;
        const popinWrap = this.popinElement.querySelector('.popin__form') as HTMLElement;

        if (popinWrap && confirmMessage) {
            popinWrap.style.display = 'none';
            confirmMessage.style.display = 'block';
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const allPopinElements = document.querySelectorAll<HTMLElement>('.popin');
    if (allPopinElements.length > 0) {
        allPopinElements.forEach(popinElement => {
            new PopinHandler(popinElement);
        });
    }
});